import CheckerMain from "../Checker/CheckerMain";
import OffMarketTabs from "./OffMarketTabs";


function OffMarketMain(){
     const getRole = localStorage.getItem("cosmosProjectRole");     

    return (
        <>
        {getRole === "maker" ?
        <OffMarketTabs />
        : 
        <CheckerMain />}
        </>

    )
}

export default OffMarketMain;